<!-- Toolbar: Breadcrumb + Upload Button -->
<div class="agrodrive-toolbar">
  @if (currentView !== 'root') {
    <nav class="agrodrive-breadcrumb" aria-label="breadcrumb">
      @if (currentView === 'device') {
        <button type="button" class="agrodrive-breadcrumb__segment agrodrive-breadcrumb__segment--link" (click)="navigateToRoot()">{{ 'agrodrive.home' | translate }}</button>
        <span class="agrodrive-breadcrumb__separator">›</span>
        <span class="agrodrive-breadcrumb__segment agrodrive-breadcrumb__segment--active">
          {{ isUserContainerSelected ? ('agrodrive.my-agrodrive' | translate) : selectedDevice?.deviceId }}
        </span>
      } @else {
        <button type="button" class="agrodrive-breadcrumb__segment agrodrive-breadcrumb__segment--link" (click)="navigateToRoot()">{{ 'agrodrive.home' | translate }}</button>
        <span class="agrodrive-breadcrumb__separator">›</span>
        <button type="button" class="agrodrive-breadcrumb__segment agrodrive-breadcrumb__segment--link" (click)="navigateBackToDevice()">
          {{ isUserContainerSelected ? ('agrodrive.my-agrodrive' | translate) : selectedDevice?.deviceId }}
        </button>
        <span class="agrodrive-breadcrumb__separator">›</span>
        <span class="agrodrive-breadcrumb__segment agrodrive-breadcrumb__segment--active">{{ 'agrodrive.' + selectedSubcategory | translate }}</span>
      }
    </nav>
  }
  <app-button
    type="button"
    color="primary"
    icon="agres-upload"
    [disabled]="!agrodriveApiResponse"
    (btnClick)="openUploadModal()"
    [title]="'agrodrive.upload-files-to-agrodrive' | translate">
  </app-button>
</div>
<!-- Upload Modal -->
<app-modal [show]="showUploadModal" [title]="'agrodrive.upload-files-to-agrodrive' | translate" size="lg">
  <div class="upload-modal">
    @if (currentStep === 'device-selection') {
    <!-- Device Selection Step -->
    <h4 class="upload-modal__title">{{ 'agrodrive.select-devices-to-upload' | translate }}</h4>
    <div class="upload-modal__device-selection">
      <p class="upload-modal__instruction">{{ 'agrodrive.choose-devices-instruction' | translate }}</p>

      <div class="upload-modal__device-option">
        <label class="upload-modal__device-label">
          <input type="checkbox" class="upload-modal__device-input"
            [checked]="isDeviceSelected(userContainerDevice)"
            (change)="toggleDeviceSelection(userContainerDevice)" />
          <span class="upload-modal__device-checkmark"></span>
          <div class="upload-modal__device-info upload-modal__device-info--user">
            <i class="agres-upload-cloud upload-modal__device-cloud-icon"></i>
            <h5 class="upload-modal__device-name">{{ 'agrodrive.my-agrodrive' | translate }}</h5>
          </div>
        </label>
      </div>
      @for (device of physicalDevices; track device.deviceId) {
      <div class="upload-modal__device-option">
        <label class="upload-modal__device-label">
          <input type="checkbox" class="upload-modal__device-input" [checked]="isDeviceSelected(device)"
            (change)="toggleDeviceSelection(device)" />
          <span class="upload-modal__device-checkmark"></span>
          <div class="upload-modal__device-info">
            <h5 class="upload-modal__device-name">{{ device.deviceId }}</h5>
          </div>
        </label>
      </div>
      }

      @if (selectedDevices.length > 0) {
      <div class="upload-modal__summary">
        <p class="upload-modal__summary-text">
          <strong>{{ selectedDevices.length }} {{ 'agrodrive.devices-selected' | translate }}</strong>
        </p>
      </div>
      }
    </div>

    <div class="upload-modal__actions">
      <app-button
        type="button"
        color="primary"
        icon="agres-action"
        [disabled]="selectedDevices.length === 0"
        (btnClick)="proceedToFileSelection()"
        [title]="getContinueButtonTitle()">
      </app-button>
      <app-button
        type="button"
        color="danger"
        icon="agres-close"
        (btnClick)="closeUploadModal()"
        [title]="'global.cancel' | translate">
      </app-button>
    </div>
    } @else {
    <!-- File Upload Step -->
    <h4 class="upload-modal__title">
      {{ 'agrodrive.upload-files-to-selected-devices' | translate: {count: selectedDevices.length, devices:
      selectedDevices.length !== 1 ? ('agrodrive.devices' | translate) : ('agrodrive.device' | translate)} }}
    </h4>

    <div class="upload-modal__file-section">
      <div class="upload-modal__form-group">
        <input type="file" id="fileInput" #fileInput multiple (change)="onFilesSelected($event)"
          accept=".zip, .shp, .shx, .dbf, .prj"
          style="display: none;" />
        <div
          class="upload-modal__dropzone"
          [class.upload-modal__dropzone--active]="isDragOver"
          (click)="fileInput.click()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          role="button"
          tabindex="0"
          (keyup.enter)="fileInput.click()"
          [attr.aria-label]="'agrodrive.choose-files' | translate">
          <i class="agres-upload upload-modal__dropzone-icon"></i>
          <p class="upload-modal__dropzone-text">{{ 'agrodrive.drag-drop-files' | translate }}</p>
          <p class="upload-modal__dropzone-hint">{{ 'agrodrive.drag-drop-or-click' | translate }}</p>
          <small class="upload-modal__help-text">{{ 'agrodrive.only-zip-files-accepted' | translate }}</small>
        </div>
      </div>

      @if (selectedFiles.length > 0) {
      <div class="upload-modal__selected-files">
        <h5 class="upload-modal__section-title">{{ 'agrodrive.selected-files' | translate }}</h5>
        <ul class="upload-modal__file-list">
              @for (file of selectedFiles; track file.name; let i = $index) {
                <li
                  class="upload-modal__file-item"
                  [class.upload-modal__file-item--invalid]="!isZipFileValid(file.name)"
                  [class.upload-modal__file-item--valid]="
                    file.name.toLowerCase().endsWith('.zip') && isZipFileValid(file.name)
                  ">
                  <span class="upload-modal__file-info">
                    <span class="upload-modal__file-name">{{ file.name }}</span>
                    <span class="upload-modal__file-meta">
                      ({{ formatFileSize(file.size) }})
                      @if (file.name.toLowerCase().endsWith('.zip') && getFileExtensions(file.name).length > 0) {
                        <span
                          class="upload-modal__file-extensions"
                          [class.upload-modal__file-extensions--invalid]="!isZipFileValid(file.name)"
                          [class.upload-modal__file-extensions--valid]="isZipFileValid(file.name)">
                          [{{ getFileExtensions(file.name).join(', ') }}]
                        </span>
                      }
                    </span>
                  </span>
                  <app-button
                    type="button"
                    color="danger"
                    size="small"
                    icon="agres-close"
                    (btnClick)="removeFile(i)">
                  </app-button>
                </li>
              }
            </ul>
            <div class="upload-modal__total-size" [class.upload-modal__total-size--exceeded]="isFileSizeExceeded()">
              <span>{{ 'agrodrive.total-size' | translate }}: {{ formatFileSize(getTotalFileSize()) }} / 100 MB</span>
              @if (isFileSizeExceeded()) {
                <span class="upload-modal__size-warning">
                  <i class="agres-alert-triangle"></i>
                  {{ 'agrodrive.file-size-exceeded' | translate }}
                </span>
              }
            </div>
      </div>
      }
    </div>

    <div class="upload-modal__target-devices">
      <h5 class="upload-modal__section-title">{{ 'agrodrive.target-devices' | translate }}</h5>
      <ul class="upload-modal__device-list">
        @for (device of selectedDevices; track device.deviceId) {
        <li class="upload-modal__device-item">
          {{ device.deviceId === USER_CONTAINER_ID ? ('agrodrive.my-agrodrive' | translate) : device.deviceId }}
        </li>
        }
      </ul>
    </div>

      <div class="upload-modal__actions">
        <app-button
          type="button"
          color="return"
          icon="agres-return"
          (btnClick)="backToDeviceSelection()"
          [title]="'global.back' | translate">
        </app-button>
        @if (isUploading) {
          <app-button
            type="button"
            color="primary"
            action="reload"
            icon="agres-reload"
            [disabled]="true"
            [title]="'agrodrive.uploading' | translate">
          </app-button>
        } @else {
          <app-button
            type="button"
            color="primary"
            icon="agres-action"
            [disabled]="selectedFiles.length === 0 || isFileSizeExceeded() || hasInvalidZipFiles()"
            (btnClick)="uploadFiles()"
            [title]="'global.send' | translate">
          </app-button>
        }
        <app-button
          type="button"
          color="danger"
          icon="agres-close"
          (btnClick)="closeUploadModal()"
          [title]="'global.cancel' | translate">
        </app-button>
    </div>
    }
  </div>
</app-modal>

<!-- Move Files Modal -->
<app-modal [show]="showMoveModal" [title]="'agrodrive.move-file' | translate" size="lg">
  <div class="upload-modal">
    @if (moveModalStep === 'file-info') {
    <!-- File Info Step -->
    <h4 class="upload-modal__title">{{ 'agrodrive.move-file-info' | translate }}</h4>
    <div class="upload-modal__file-section">
      <div class="upload-modal__selected-files">
        <h5 class="upload-modal__section-title">{{ 'agrodrive.file-to-move' | translate }}</h5>
        <div class="upload-modal__file-item upload-modal__file-item--valid">
          <span class="upload-modal__file-info">
            <span class="upload-modal__file-name">{{ fileToMove?.fileName }}</span>
            <span class="upload-modal__file-meta">
              ({{ 'agrodrive.' + fileToMove?.category | translate }})
            </span>
          </span>
        </div>
      </div>

      <div class="upload-modal__target-devices">
        <h5 class="upload-modal__section-title">{{ 'agrodrive.source-device' | translate }}</h5>
        <p class="upload-modal__device-item">
          {{ fileToMove?.sourceDevice?.deviceId }}
        </p>
      </div>
    </div>

    <div class="upload-modal__actions">
      <app-button
        type="button"
        color="primary"
        icon="agres-action"
        (btnClick)="proceedToDeviceSelectionForMove()"
        [title]="'agrodrive.select-target-devices' | translate">
      </app-button>
      <app-button
        type="button"
        color="danger"
        icon="agres-close"
        (btnClick)="closeMoveModal()"
        [title]="'global.cancel' | translate">
      </app-button>
    </div>
    } @else {
    <!-- Device Selection Step for Move -->
    <h4 class="upload-modal__title">{{ 'agrodrive.select-target-devices-for-move' | translate }}</h4>
    <div class="upload-modal__device-selection">
      <p class="upload-modal__instruction">{{ 'agrodrive.choose-devices-to-copy-file' | translate }}</p>

      @for (device of getAvailableTargetDevices(); track device.deviceId) {
      <div class="upload-modal__device-option">
        <label class="upload-modal__device-label">
          <input type="checkbox" class="upload-modal__device-input" [checked]="isMoveTargetDeviceSelected(device)"
            (change)="toggleMoveTargetDeviceSelection(device)" />
          <span class="upload-modal__device-checkmark"></span>
          @if (device.deviceId === USER_CONTAINER_ID) {
            <div class="upload-modal__device-info upload-modal__device-info--user">
              <i class="agres-upload-cloud upload-modal__device-cloud-icon"></i>
              <h5 class="upload-modal__device-name">{{ 'agrodrive.my-agrodrive' | translate }}</h5>
            </div>
          } @else {
            <div class="upload-modal__device-info">
              <h5 class="upload-modal__device-name">{{ device.deviceId }}</h5>
            </div>
          }
        </label>
      </div>
      }

      @if (moveTargetDevices.length > 0) {
      <div class="upload-modal__summary">
        <p class="upload-modal__summary-text">
          <strong>{{ moveTargetDevices.length }} {{ 'agrodrive.devices-selected' | translate }}</strong>
        </p>
      </div>
      }
    </div>

    <div class="upload-modal__actions">
      <app-button
        type="button"
        color="return"
        icon="agres-return"
        (btnClick)="backToFileInfo()"
        [title]="'global.back' | translate">
      </app-button>
      @if (isMoving) {
        <app-button
          type="button"
          color="primary"
          action="reload"
          icon="agres-reload"
          [disabled]="true"
          [title]="'agrodrive.moving' | translate">
        </app-button>
      } @else {
        <app-button
          type="button"
          color="primary"
          icon="agres-action"
          [disabled]="moveTargetDevices.length === 0"
          (btnClick)="moveFile()"
          [title]="'global.copy' | translate">
        </app-button>
      }
      <app-button
        type="button"
        color="danger"
        icon="agres-close"
        (btnClick)="closeMoveModal()"
        [title]="'global.cancel' | translate">
      </app-button>
    </div>
    }
  </div>
</app-modal>

<!-- Full Map Modal -->
<app-modal [show]="showFullMap" [title]="selectedPreviewFile?.fileName" size="xl">
  <div class="upload-modal">
    @if (googleMapsApiLoaded && (previewPolygons.length || previewPolylines.length)) {
      <google-map
        #fullMap="googleMap"
        width="100%"
        height="600px"
        [options]="previewMapOptions"
        (tilesloaded)="onPreviewMapTilesLoaded(fullMap.googleMap)">
        @for (poly of previewPolygons; track $index) {
          <map-polygon
            [paths]="poly.paths"
            [options]="{ fillColor: poly.fillColor, fillOpacity: poly.fillOpacity, strokeColor: poly.strokeColor, strokeWeight: poly.strokeWeight }">
          </map-polygon>
        }
        @for (line of previewPolylines; track $index) {
          <map-polyline
            [path]="line.path"
            [options]="{ strokeColor: '#3388ff', strokeWeight: 2 }">
          </map-polyline>
        }
      </google-map>
      @if (previewLegend.length) {
        <div class="preview-modal__legend">
          @for (item of previewLegend; track $index) {
            <div class="preview-modal__legend-item">
              <span class="preview-modal__legend-swatch" [style.background-color]="item.color"></span>
              <span class="preview-modal__legend-label">{{ item.label }}</span>
            </div>
          }
        </div>
      }
    }
    <div class="upload-modal__actions">
      <app-button
        type="button"
        color="return"
        icon="agres-return"
        (btnClick)="closeFullMapModal()"
        [title]="'global.close' | translate">
      </app-button>
    </div>
  </div>
</app-modal>

<!-- Root View: Device Folders -->
@if (currentView === 'root') {
  <h3 class="field__section-title">{{ 'agrodrive.banner-title' | translate }}</h3>
  <div class="field__info">
    <span>{{ 'agrodrive.banner-description' | translate }}</span>
  </div>
  <div class="field__info">
    <p class="field__info-label">{{ 'agrodrive.banner-features-title' | translate }}</p>
    <ul class="field__info-list">
      <li>{{ 'agrodrive.banner-feature-1' | translate }}</li>
      <li>{{ 'agrodrive.banner-feature-2' | translate }}</li>
      <li>{{ 'agrodrive.banner-feature-3' | translate }}</li>
      <li>{{ 'agrodrive.banner-feature-4' | translate }}</li>
    </ul>
  </div>
  @if (agrodriveApiResponse) {
    <h3 class="field__section-title field__section-title--spaced">{{ 'agrodrive.cloud-files-title' | translate }}</h3>
    <div class="field__info">
      <span>{{ 'agrodrive.cloud-files-description' | translate }}</span>
    </div>
    <div class="agrodrive-folder-grid">
      <button
        type="button"
        class="agrodrive-folder-card"
        [class.agrodrive-folder-card--disabled]="!userContainer"
        [disabled]="!userContainer"
        [attr.title]="!userContainer ? ('agrodrive.cloud-files-empty-hint' | translate) : null"
        (click)="userContainer && navigateToDevice(userContainer)">
        <i class="agres-upload-cloud agrodrive-folder-card__cloud-icon"></i>
        <span class="agrodrive-folder-card__name">{{ 'agrodrive.my-agrodrive' | translate }}</span>
        @if (!userContainer) {
          <span class="agrodrive-folder-card__empty-hint">{{ 'agrodrive.cloud-files-empty-hint' | translate }}</span>
        }
      </button>
    </div>
  }

  <h3 class="field__section-title field__section-title--spaced">{{ 'agrodrive.synced-devices-title' | translate }}</h3>
  @if (!physicalDevices.length) {
    <div class="upload-modal__empty-message">
      <h3>{{ 'agrodrive.no-device-linked' | translate }}</h3>
    </div>
  } @else {
    <div class="agrodrive-folder-grid">
      @for (device of physicalDevices; track device.deviceId) {
        <button type="button" class="agrodrive-folder-card" (click)="navigateToDevice(device)">
          @if (device.imageUrl === undefined) {
            <div class="agrodrive-folder-card__image-loading">
              <img
                src="assets/images/tecomec/spinner-tecomec.svg"
                alt="loading"
                class="agrodrive-folder-card__spinner" />
            </div>
          } @else {
            <img
              [src]="device.imageUrl"
              class="agrodrive-folder-card__device-image"
              [alt]="device.deviceType"
              (error)="onDeviceImageError($event, device)"
            />
          }
          <span class="agrodrive-folder-card__name">{{ device.deviceId }}</span>
        </button>
      }
    </div>
  }
}

<!-- Device View: Subcategory Folders -->
@if (currentView === 'device') {
  <div class="agrodrive-folder-grid">
    @for (subcategory of activeSubcategories; track subcategory) {
      <button type="button" class="agrodrive-folder-card" (click)="navigateToSubcategory(subcategory)">
        <svg class="agrodrive-folder-card__icon" viewBox="0 0 56 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 0H20L26 8H52C54.2 8 56 9.8 56 12V44C56 46.2 54.2 48 52 48H4C1.8 48 0 46.2 0 44V4C0 1.8 1.8 0 4 0Z" fill="#E89E0A"/>
          <path d="M0 16C0 13.8 1.8 12 4 12H52C54.2 12 56 13.8 56 16V44C56 46.2 54.2 48 52 48H4C1.8 48 0 46.2 0 44V16Z" fill="#F5B731"/>
        </svg>
        <span class="agrodrive-folder-card__name">{{ 'agrodrive.' + subcategory | translate }}</span>
        @if (getSubcategoryCount(subcategory) > 0) {
          <span class="agrodrive-folder-card__count">{{ getSubcategoryCount(subcategory) }}</span>
        }
      </button>
    }
  </div>
}

<!-- Subcategory View: Files -->
@if (currentView === 'subcategory' && selectedDevice && selectedSubcategory) {
  @if (selectedSubcategory === 'tasks') {
    @if (!selectedDevice.tasks.length) {
      <div class="upload-modal__empty-message">
        <h3>{{ 'agrodrive.no-files' | translate }}</h3>
      </div>
    } @else {
      <div class="panel">
        <div class="panel__group">
          <div class="panel__search">
            <div class="field">
              <div class="field__wrap">
                <input
                  id="agrodrive-task-search"
                  type="search"
                  class="field__input"
                  [attr.aria-label]="'global.search' | translate"
                  [placeholder]="'global.search' | translate"
                  [value]="searchQuery"
                  (input)="searchQuery = $any($event.target).value" />
                <span class="field__view">
                  <app-agres-icons iconsClass="agres-search"></app-agres-icons>
                </span>
              </div>
            </div>
          </div>
          <div class="panel__filter">
            <select
              id="agrodrive-task-sort-order"
              class="field__input"
              [attr.aria-label]="'archive.sort-by' | translate"
              [(ngModel)]="selectedTaskSortOrder">
              @for (option of taskSortOptions; track option.value) {
                <option [value]="option.value">{{ option.labelKey | translate }}</option>
              }
            </select>
          </div>
        </div>
      </div>
      @if (!filteredTasks.length) {
        <div class="file-browser__empty">
          <p>{{ 'agrodrive.no-files-match' | translate }}</p>
        </div>
      }
      <div class="device-accordion__grid">
        @for (entry of filteredTasks; track trackByTask(entry)) {
          <ng-template #taskCardImage>
            <app-gestao-arquivo-card-image [workId]="entry.metadata?.parsedTaskId">
            </app-gestao-arquivo-card-image>
          </ng-template>

          <ng-template #defaultCardImage>
            <div class="default-card-image"></div>
          </ng-template>

          <app-card
            [id]="entry.metadata?.parsedTaskId"
            [title]="entry.fileName"
            [content]="
              entry
                | taskContentTranslations
                : [
                    {
                      sourceKey: 'metadata.createdAt',
                      labelKey: 'agrodrive.created-at',
                      transform: 'date',
                    },
                    {
                      sourceKey: 'metadata.completedAt',
                      labelKey: 'agrodrive.completed-at',
                      transform: 'date',
                    },
                  ]
                : translateService.currentLang
            "
            [cardImage]="
              entry.metadata?.status | cardImage: defaultCardImage : defaultCardImage : taskCardImage
            "
            [statusTranslationPrefix]="'global.'"
            [status]="entry.metadata?.status"
            [onCardClicked]="getTaskCardClickHandler(entry)">
          </app-card>
        }
      </div>
    }
  } @else {
    @if (!getDeviceSubcategoryFiles(selectedSubcategory).length) {
      <div class="upload-modal__empty-message">
        <h3>{{ 'agrodrive.no-files' | translate }}</h3>
      </div>
    } @else {
      <div class="file-browser" [class.file-browser--with-panel]="selectedPreviewFile">
        <!-- Left: File list -->
        <div class="file-browser__list">
          <div class="file-browser__search">
            <i class="agres-search file-browser__search-icon"></i>
            <input
              type="text"
              class="file-browser__search-input"
              [placeholder]="'agrodrive.search-files' | translate"
              [value]="searchQuery"
              (input)="searchQuery = $any($event.target).value" />
          </div>

          @if (!filteredFiles.length) {
            <div class="file-browser__empty">
              <p>{{ 'agrodrive.no-files-match' | translate }}</p>
            </div>
          } @else {
            <div class="file-browser__grid">
              @for (entry of filteredFiles; track trackByEntry($index, entry)) {
                <div
                  class="file-browser__card"
                  [class.file-browser__card--selected]="selectedPreviewFile?.fileName === entry.fileName"
                  (click)="onFileCardClick(entry)"
                  tabindex="0"
                  (keyup.enter)="onFileCardClick(entry)"
                  [attr.aria-label]="entry.fileName">
                  <div class="file-browser__card-icon">   
                      <i class="agres-file"></i>
                  </div>
                  <div class="file-browser__card-info">
                    <p class="file-browser__card-name" [title]="entry.fileName">{{ entry.fileName }}</p>
                  </div>
                  @if (selectedPreviewFile?.fileName === entry.fileName) {
                    <span class="file-browser__card-check"><i class="agres-check"></i></span>
                  }
                  <div class="file-browser__card-actions" (click)="$event.stopPropagation()">
                    <app-button
                      type="button"
                      color="secondary"
                      size="small"
                      icon="agres-download"
                      [title]="'global.download' | translate"
                      (btnClick)="onFileDownloadClick(entry, $event)">
                    </app-button>
                    <app-button
                      type="button"
                      color="info"
                      size="small"
                      icon="agres-copy"
                      [title]="'global.copy' | translate"
                      (btnClick)="onFileMoveClick(entry, $event)">
                    </app-button>
                  </div>
                </div>
              }
            </div>
          }
        </div>

        <!-- Right: Preview panel -->
        @if (selectedPreviewFile) {
          <div class="file-browser__preview">
            <div class="file-browser__preview-header">
              <span class="file-browser__preview-title">{{ 'agrodrive.file-preview' | translate }}</span>
              <button type="button" class="file-browser__preview-close" (click)="clearPreview()" [attr.aria-label]="'global.close' | translate">
                <i class="agres-close"></i>
              </button>
            </div>
            <p class="file-browser__preview-filename">{{ selectedPreviewFile.fileName }}</p>

            @if (isLoadingPreview) {
              <div class="preview-modal__loading">
                <img src="assets/images/tecomec/spinner-tecomec.svg" alt="loading" class="upload-modal__spinner" />
                <p>{{ 'agrodrive.preview-loading' | translate }}</p>
              </div>
            } @else if (googleMapsApiLoaded && (previewPolygons.length || previewPolylines.length)) {
              @if (selectedSubcategory === 'variableRateMaps' && previewAvailableFields.length > 1) {
                <div class="file-browser__field-selector">
                  <label class="file-browser__field-label" for="valueFieldSelect">{{ 'agrodrive.select-field' | translate }}</label>
                  <select
                    id="valueFieldSelect"
                    class="file-browser__field-select"
                    [value]="selectedValueField"
                    (change)="onValueFieldChange($any($event.target).value)">
                    @for (field of previewAvailableFields; track field) {
                      <option [value]="field">{{ field }}</option>
                    }
                  </select>
                </div>
              }
              <div class="file-browser__map-container">
                <google-map
                  #sideMap="googleMap"
                  width="100%"
                  height="100%"
                  [options]="previewMapOptions"
                  (tilesloaded)="onPreviewMapTilesLoaded(sideMap.googleMap)">
                  @for (poly of previewPolygons; track $index) {
                    <map-polygon
                      [paths]="poly.paths"
                      [options]="{ fillColor: poly.fillColor, fillOpacity: poly.fillOpacity, strokeColor: poly.strokeColor, strokeWeight: poly.strokeWeight }">
                    </map-polygon>
                  }
                  @for (line of previewPolylines; track $index) {
                    <map-polyline
                      [path]="line.path"
                      [options]="{ strokeColor: '#3388ff', strokeWeight: 2 }">
                    </map-polyline>
                  }
                </google-map>
              </div>

@if (previewLegend.length && previewStats?.field) {
                <div class="file-browser__legend">
                  <p class="file-browser__gradient-title">{{ 'agrodrive.' + selectedSubcategory | translate }}</p>
                  @for (item of previewLegend; track $index) {
                    <div class="file-browser__legend-item">
                      <span class="file-browser__legend-swatch" [style.background-color]="item.color"></span>
                      <span class="file-browser__legend-label">{{ item.label }}</span>
                    </div>
                  }
                </div>
              }

            } @else if (!isLoadingPreview && selectedPreviewFile && !selectedPreviewFile.fileName.toLowerCase().endsWith('.zip')) {
              <div class="file-browser__no-preview">
                <i class="agres-file file-browser__no-preview-icon"></i>
                <p>{{ 'agrodrive.no-preview-available' | translate }}</p>
              </div>
            }
          </div>
        }
      </div>
    }
  }
}